module.exports = __webpack_public_path__ + "static/media/ship.2677d54d.png";